import { http } from '@/core/helpers/http.helper';
import { TIPTAP_ENDPOINTS } from './tiptap.endpoints';
import { TiptapToken } from './tiptap.interface';

export class TiptapService {
   async getToken() {
      const response = await http.get<TiptapToken>(TIPTAP_ENDPOINTS.GET_TOKEN());
      return response.data;
   }
}
